<template>
  <div class="nodata-wrap" :style="{ width: wrapWidth, height: wrapHeight }">
    <div class="nodata-inner">
      <img class="nodata-img" :src="emptyImg" alt="" :style="{ width: imgSize + 'px', height: imgSize + 'px' }" />
      <span>{{ $t('lang.OtherModule.k003') }}</span>
    </div>
  </div>
</template>

<script>
import emptyImg from './empty.webp'

export default {
  name: 'NoData',
  props: {
    wrapWidth: {
      type: String,
      default: '100%',
    },
    wrapHeight: {
      type: String,
      default: '400px',
    },
    svgWidth: {
      type: Number,
      default: 120,
    },
    svgHeight: {
      type: Number,
      default: 120,
    },
  },
  data() {
    return {
      emptyImg,
    }
  },
  computed: {
    imgSize() {
      return this.svgWidth || this.svgHeight || 120
    },
  },
}
</script>

<style scoped>
.nodata-wrap {
  width: 100%;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nodata-inner {
  width: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.nodata-img {
  display: block;
  width: 120px;
  height: 120px;
  object-fit: contain;
}

span {
  width: 100%;
  color: #6a6a6a;
  font-family: var(--string-font);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  word-break: break-word;
}
</style>
